// extracted by mini-css-extract-plugin
export default {"root":"xzbSMMKK","block":"rKd3Jnid"};